import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/agent-traces/ephemeral')({
    beforeLoad: () => {
        throw redirect({ to: '/admin/agent-traces/caregiver', replace: true });
    },
});
